import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import useAuthStore from '../stores/authStore';
import { Eye, EyeOff, LogIn } from 'lucide-react';

const Login = () => {
  const navigate = useNavigate();
  const { login, loading, error, warning, clearError, clearWarning } = useAuthStore();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [showWarning, setShowWarning] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();
    clearWarning();
    setShowWarning(false);
    const result = await login(formData.email, formData.password);
    if (result === 'otp_required') {
      navigate('/first-login-otp', { state: { identifier: formData.email } });
      return;
    }
    if (result && result.success) {
      if (result.warnings?.length) {
        setShowWarning(true);
        return;
      }
      navigate('/dashboard');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            {/* Restored the Tickmarks Logo */}
            <img
              src="/tickmarks-logo.png"
              alt="Tickmarks Logo"
              style={{ height: '40px', marginBottom: '16px' }}
            />
          </div>
          <div className="login-subtitle">Sign in to TimeTracker</div>
        </div>

        {error && (
          <div className="login-error" style={{ marginBottom: '20px' }}>
            {error}
          </div>
        )}

        {showWarning && warning && (
          <div className="login-error" style={{ marginBottom: '20px', borderColor: 'var(--warning)', color: 'var(--warning)', background: 'rgba(255, 213, 128, 0.15)' }}>
            <strong>Timezone mismatch:</strong> {warning}
          </div>
        )}

        {showWarning && (
          <button
            type="button"
            className="btn btn-secondary btn-block"
            onClick={() => navigate('/dashboard')}
            style={{ width: '100%', marginTop: '10px' }}
          >
            Continue to dashboard
          </button>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email or Username</label>
            <input
              type="text"
              className="form-input"
              placeholder="Enter your email or username"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-input"
                placeholder="Enter your password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                style={{ paddingRight: '48px' }}
              />
              <button
                type="button"
                className="btn-icon"
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--text-secondary)'
                }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <Link
              to="/forgot-password"
              style={{
                fontSize: '12px',
                color: 'var(--primary)',
                marginTop: '8px',
                display: 'block',
                textDecoration: 'none'
              }}
            >
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={loading}
            style={{ width: '100%', marginTop: '10px' }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div style={{ marginTop: '24px', textAlign: 'center' }}>
          <p className="text-secondary text-sm">
            Don't have an account?{' '}
            <Link to="/register" style={{ color: 'var(--primary)', fontWeight: 500 }}>
              Register here
            </Link>
          </p>
        </div>

        {/* Demo Credentials section has been removed */}
      </div>
    </div>
  );
};

export default Login;